import React from 'react'
import clsx from 'clsx'
import { addMonths, isSameMonth, setMonth } from 'date-fns'

import type { CalendarProps } from './Calendar'
import format from 'libs/dateFns/format'

export interface MonthCalendarProps extends Pick<CalendarProps, 'value'> {
  displayDate: Date
  onChange: (value: Date) => void
}

const MonthCalendar: React.FC<MonthCalendarProps> = ({
  value,
  displayDate,
  onChange,
}: MonthCalendarProps): JSX.Element => {
  const base = 'calendar'
  const calendarSize = 3 * 4
  const itemCn = (month: Date) =>
    clsx(
      `${base}__calendar-item`,
      `${base}__calendar-item--month`,
      value && isSameMonth(value, month) && `${base}__calendar-item--selected`,
    )

  const months: Date[] = Array(calendarSize)
    .fill(setMonth(displayDate, 0))
    .map((date, incrementor) => addMonths(date, incrementor))

  return (
    <div
      className={`${base}__calendar-body--month`}
      data-testid='calendar-container-month'
    >
      {months.map((_month, index) => (
        <div
          key={index}
          className={itemCn(_month)}
          onClick={() => onChange(_month)}
          data-testid={`calendar-month-${format(_month, 'M')}`}
        >
          {format(_month, 'LLLL')}
        </div>
      ))}
    </div>
  )
}

export default MonthCalendar
